import { ReactNode, MouseEvent } from 'react'
import { useDispatch } from 'react-redux'
import classnames from 'classnames'

import PremiumTag from '~/apps/consumer/pages/Quotes/Builder/QuoteDetailPage/PremiumTag'
import Link from '~/core/Link'
import { setAppPreferences } from '~/redux-modules/preferences'

export interface navItemsType {
    label: ReactNode
    icon?: ReactNode
    name?: string
    href?: string
    placement: string
    to?: string
    navKey: string
    id?: string
    disabled?: boolean
    target?: '_blank' | '_self' | '_parent' | '_top' | undefined
    handleSetSidebar?: (appName: string) => void
    onClick?: (evt?: MouseEvent) => void
    dataTestTarget?: string
    isPremium?: boolean
    collapsed?: boolean
}

const MenuItem = (props: navItemsType) => {
    const {
        label,
        to,
        name,
        placement,
        href,
        target,
        navKey,
        id,
        disabled,
        handleSetSidebar,
        onClick = () => setPreference(navKey),
        isPremium,
        collapsed,
    } = props
    const dispatch = useDispatch()

    const setPreference = (appName?: string) => {
        if (!appName || !id || appName === 'stop-impersonating') {
            return
        }

        const action = setAppPreferences(id || '', appName)

        handleSetSidebar?.(appName)
        dispatch(action)
    }

    return (
        <Link
            to={to}
            href={href}
            target={target}
            name={name ?? (typeof label === 'string' ? label : undefined)}
            placement={placement}
            disabled={disabled}
            onClick={onClick}
        >
            <span className={classnames('linkLabel', 'premiumTagContainer')}>
                {label}
                {!collapsed && isPremium && (
                    <div>
                        <PremiumTag isClickOverride={true} />
                    </div>
                )}
            </span>
        </Link>
    )
}

export default MenuItem
